<template>

  <div class="fwptBox">
   <div class="fwpt">
    <div class="fwptTitle">{{columnTitle}}</div>
    <div class="fwptCont">{{columnDesc}}</div>
    <div class="fwptListBox">
      <div class="fpListLeft">

        <div :class=" index == flag ? 'islistItem' : 'listItem' " v-for = '(item,index) in list' :key = 'index' >
          <div class="xunhuan" @click = "handleClickitem(index,item.id)">
            <div class="itemLeft" >
              <img v-if = 'item.geoProdUrl' :src="commonUrl + item.geoProdUrl" alt="">
              <img v-else  src="../../../../static/images/pro_img.png" alt="">
            </div>
            <div class="itemRight">
              <div class="rightTitle" >
                <p :class = "flag == index ? 'istitleCon': 'titleCon' " >{{ item.geoProdName }}</p>
              </div>
              <div class="itemwrite">{{ item.authHolder }}</div>
              <div class="liulan" @click = "handleClickcpdetail(item.geoId)">查看详情</div>
            </div>
          </div>
        </div>
        

      </div>
      <div class="fpListRight">

        <div class="fprtu">
          <div class="rprtuiTitle">{{geoProdName}}风味谱 </div>
          <div class = 'fwpimg'>
            <img class= 'imgshow'  :src="commonUrl+flavorUrl" alt="">
          </div>
          <div class = 'fwptitlebox'>{{geoProdName}}风味谱说明</div>
          <div class="fwptcontent">• {{ flavorDesc }}</div>
          <!-- <div class = 'echerts' id = 'echartsBox'>
            <img class =  'echImg'  :src="commonUrl+flavorUrl" alt="">
          </div> -->
        </div>

        <div class="fprtu">
          <div class="rprtuiTitle">{{geoProdName}}品质谱 </div>
          <div class = 'fwpimg'>
            <img class= 'imgshow'  :src="commonUrl+qualityUrl" alt="">
          </div>
          <div class = 'fwptitlebox'>{{geoProdName}}品质谱说明</div>
          <div class="fwptcontent">•{{ qualityDesc}}</div>
          <!-- <div class = 'echerts' id = 'echartsBox'>
            <img class =  'echImg'  :src="commonUrl+flavorUrl" alt="">
          </div> -->
        </div>
        
        <!-- <div class="fprinclude">
          <div class="includeTitle">{{ geoProdName }}</div>
          <div class="includeWrite" v-html = 'attrContent'></div>
          <div class="includeImg" v-if = 'geoUrls.length > 0 '>
            <img class = 'inImg' v-for = "(item,index) in geoUrls"  :src="commonUrl+ item" alt="" :key = 'index'>
          </div>
          <div class="includeTitle">{{geoProdName}}风味谱图说明 </div>
          <div class="includecont">{{ flavorDesc }}</div>
        </div> -->
      </div>

    </div>
   </div>
   
  </div>


</template>

<script>

export default {
mounted() {
  this.commonUrl = commonUrl;
  this.getTitleInfo()
  this.getListInfo()
},
data () {
  return {
    columnTitle:'',
    columnDesc:'',
    id:'',
    commonUrl:'',
    flag:'0',
    list:[],
    flavorDesc:'',//风味普说明
    qualityDesc:'',//品质普说明
    attrContent:'',//品质谱说明
    geoUrls:[],//图片
    flavorUrl: "",//风味谱图
    qualityUrl:'',//品质谱图
    attrContent: "",//栏目内容
    attrTitle: "",//栏目名称
    geoProdName:'',

  }
},
methods: {
    handleClickitem(e,id){
      this.flag = e;
      this.id = id 
      this.getlistDetail()
    },
    getListInfo(){
      this.Axios({
          url: Action.FLOORINDEX_GETFLOORINDEXSHOWFLAVOR,
          method: "post",
          data: {
              
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {//成功发送
              this.list = data.result.list;
              this.id = this.list[0].id
              this.getlistDetail()
          } 
          else {
            this.$message({
                showClose: true,
                message: '验证码发送失败',
                type: 'error'
            });
          }
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    getlistDetail(){
      this.Axios({
          url: Action.FLOORINDEX_GETFLOORINDEXSHOWFLAVORDETAIL,
          method: "post",
          data: {
              id:this.id
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {//成功发送
            // if(data.result.flavorDesc){
            //   data.result.flavorDesc.length>50?  this.flavorDesc= data.result.flavorDesc.split(0,50)+'...':this.flavorDesc= data.result.flavorDesc 
            // }
            // if(data.result.qualityDesc){
            //   data.result.qualityDesc.length>50?  this.qualityDesc= data.result.qualityDesc.split(0,50)+'...':this.qualityDesc= data.result.qualityDesc 
            // }
           
            this.flavorDesc= data.result.flavorDesc ;//风味普说明
            this.qualityDesc= data.result.qualityDesc ;//品质谱说明
            this.geoUrls= data.result.geoUrls ;//图片
            this.flavorUrl= data.result.flavorUrl ;//风味谱图
            this.qualityUrl= data.result.qualityUrl ;//品质谱图
            this.attrContent= data.result.attrContent ;//栏目内容
            this.attrTitle= data.result.attrTitle ;//栏目名称
            this.geoProdName = data.result.geoProdName;
          } 
          else {
            this.$message({
                showClose: true,
                message: '验证码发送失败',
                type: 'error'
            });
          }
          
      }).catch(function (response) {
          console.log(response);
      });
    },
    handleClickcpdetail(id){
      window.open('productSeachDetails?id='+id,'_blank');
    },
    getTitleInfo(){
      this.Axios({
          url: Action.FLOORINDEX_GETFLOORINDEXSHOWOTHER,
          method: "post",
          data: {
            sort:'8'
          }
      }).then( (res) => {
          var data = res.data;
          if(data.code=='000') {//成功发送
            this.columnTitle = data.result.columnTitle
            this.columnDesc = data.result.columnDesc
          } 
          else {
            this.$message({
                showClose: true,
                message: '验证码发送失败',
                type: 'error'
            });
          }
          
      }).catch(function (response) {
          console.log(response);
      });
      
    }
//     echartsInit(){
//        let chart  =   this.$echarts.init(document.getElementById("echartsBox"));
//             // 监听屏幕变化自动缩放图表
//             window.onresize = () => {
//                 chart.resize();
//             };
//             var option = {
//               backgroundColor: "#fff",
//               color: ["#2c6eff","#ff964a" ],
//               tooltip: {},
            
//               legend: {
//                 show: true,
//                 icon: "circle",
//                 top: 20,
//                 right:0,
//                 itemWidth: 6,
//                 itemHeight: 6,
//                 itemGap: 10,
//                 orient:'vertical',
//                 data: ["各个属性满分", "实际品评得分"],
//                 textStyle: {
//                   fontSize: 14,
//                   color: "#818d99",
//                 },
//               },
//               radar: {
//                 // shape: 'circle',
//                 center:['50%','60%'],
//                 name: {
//                   textStyle: {
//                     color: "#222",
//                     fontSize:14,
//                     borderRadius: 3,
//                     padding: [3, 5],
//                   },
//                 },
//                 indicator: [
//                   {
//                     name: "资金周转",
//                     max: 6500,
//                   },
//                   {
//                     name: "其他",
//                     max: 16000,
//                   },
//                   {
//                     name: "金融理财",
//                     max: 30000,
//                   },
//                   {
//                     name: "投资",
//                     max: 38000,
//                   },
//                   {
//                     name: "个人消费",
//                     max: 52000,
//                   },
//                   {
//                     name: "固定资产",
//                     max: 25000,
//                   },
                  
//                 ],
//                 splitArea: {
//                   // 坐标轴在 grid 区域中的分隔区域，默认不显示。
//                   show: true,
//                   areaStyle: {
//                     // 分隔区域的样式设置。
//                      color: ["#fff"], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
//                   },
//                 },
//                 // axisLabel:{//展示刻度
//                 //     show: true
//                 // },
//                 axisLine: {
//                   //指向外圈文本的分隔线样式
//                   lineStyle: {
//                     color: "#bdd3e9",
//                   },
//                 },
//                 splitLine: {
//                   lineStyle: {
//                     color: "#bdd3e9", // 分隔线颜色
//                     width: 1, // 分隔线线宽
//                   },
//                 },
//               },

//               series: [
//                 {
//                   type: "radar",
//                   radius: ["40%", "65%"],
//                   center: ["10%", "54%"],
//                   data: [
//                     {
//                       value: [6000, 10000, 28000, 35000, 50000, 19000],
//                       name: "各个属性满分",
//                       areaStyle: {
//                         normal: {
//                           color: "#f2f2f2",//绘制图的背景颜色
//                         },
//                       },
//                     },
//                     {
//                       value: [5000, 8000, 20000, 31000, 42000, 17000],
//                       name: "实际品评得分",
//                       areaStyle: {
//                         normal: {
//                           color: "#ff964a",
//                         },
//                       },
//                     },
//                   ],
//                 },
//               ],
//             };
//        
//             chart.setOption(option);
//         }
    
},

}
</script>


<style lang="less" scoped>

.fwptBox{
  width:100%;
  height:790px;
  background:#f2f5fa;
  .fwpt{
    width:1180px;
    margin : 0 auto;
    height:790px;
    padding-top:26px;
    .fwptTitle{
      height: 40px;
      font-size: 28px;
      line-height: 40px;
      color: #222222;
      font-weight:900;
      margin-bottom:5px;
      text-align: center;
    }
    .fwptCont{
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #222222;
      text-align: center;
      margin-bottom:40px;
    }
    .fwptListBox{
      width:1180px;
      height:610px;
      background:#fff;
      display: flex;
      justify-content: space-between;
      .fpListLeft{
        width: 245px;
        height: 610px;
        box-shadow: 0px 2px 8px 0px 
          #efefef;
        border-radius: 4px;
        overflow: auto;
        .islistItem{
          width: 240px;
	        height: 147px;
          padding:20px 13px 0px;
          cursor: pointer;
          background-color: #ffffff;
          box-shadow: 0px 0px 8px 0px 
            #89aeff;
          border-radius: 4px;
          margin-left:2px;
          margin-top:3px;
        }
        .listItem{
          width: 240px;
	        height: 147px;
          padding:20px 13px 0px;
          cursor: pointer;
          border-radius: 4px;
          margin-left:2px;
          margin-top:3px;
         
        
        }
        .xunhuan{
            display: flex;
            border-bottom: 1px solid #efefef;
            padding-bottom:20px;
            .itemLeft{
                width: 88px;
                height: 88px;
                background-color: #d8d8d8;
                border-radius: 5px;
              }
              .itemRight{
                flex:1;
                margin-left:12px;
                .rightTitle{
                  width:100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .istitleCon{
                    width:90px;
                    height: 22px;
                    font-size: 16px;
                    font-weight: 900;
                    color: #2c6eff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap;
                  }
                  .titleCon{
                    width:90px;
                    height: 22px;
                    font-size: 16px;
                    font-weight: 900;
                    color: #222222;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap;
                  }
                  .yjImg{
                    width: 14px;
                    height: 14px;
                  }
                }
                .itemwrite{
                  width: 114px;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 20px;
                  letter-spacing: 0px;
                  color: #818d99;
                }
                .liulan{
                  width: 77px;
                  height: 20px;
                  font-family: PingFangSC-Regular;
                  font-size: 12px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 20px;
                  letter-spacing: 0px;
                  color: #ff964a;
                  margin-top:6px;
                }
              }
          }

        .listItem:hover{
          background-color: #ffffff;
          box-shadow: 0px 0px 8px 0px 
            #89aeff;
          border-radius: 4px;
        }
        .xunhuan:hover .itemRight .rightTitle .titleCon{
          color:#2c6eff;
        }
      }
      .fpListLeft::-webkit-scrollbar{
        display: none;
      }
      .fpListRight{
        width: 924px;
        height: 610px;
        box-shadow: 0px 2px 8px 0px 
          #efefef;
        border-radius: 4px;
        padding:20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .fprtu{
          width:432px;
          height:570px;
          .rprtuiTitle{
            // width: 180px;
            height: 44px;
            font-size: 20px;
            font-weight: 900;
            color: #222222;
            
          }
          .fwpimg{
            width: 432px;
            height: 432px;
            border: solid 1px #dfdfdf;
            padding: 10px;
            box-sizing: border-box;
            .imgshow{
              width:100%;
              height:100%;
            }
          }
          .fwptitlebox{
            height:22px;
            width:100%;
            background:url('../../../../static/images/fwpticon.svg') no-repeat ;
            margin: 17px 0 ;
            box-sizing: border-box;
            line-height:22px;
            padding-left:30px;
            font-weight:900;
          }
          .fwptcontent{
            width: 432px;
            height: 50px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #818d99;
            overflow: auto;
          }
          .fwptcontent::-webkit-scrollbar{
            display: none;
          }
          // .echerts{
          //     width:100%;
          //     height:540px;
          //     .echImg{
          //       width:460px;
          //       height:540px;
          //     }
          //   }

        }
       
        // .fprinclude{
        //   width:368px;
        //   height:570px;
        //   overflow: auto;
        //   .includeTitle{
        //     width:368px;
        //     height: 28px;
        //     font-size: 20px;
        //     font-weight: 900;
        //     color: #222222;
        //     margin-bottom:15px;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        //     white-space: nowrap;
            
        //   }
        //   .includeWrite{
        //     width: 368px;
        //     font-family: PingFangSC-Regular;
        //     font-size: 14px;
        //     font-weight: normal;
        //     font-stretch: normal;
        //     line-height: 24px;
        //     letter-spacing: 0px;
        //     color: #818d99;
        //   }
        //   .includeImg{
        //     display: flex;
        //     flex-wrap: wrap;
        //     .inImg{
        //       width: 92px;
        //       height: 93px;
        //       background-color: #d8d8d8;
        //       border-radius: 5px;
        //       margin:12px 20px 28px 0 ;
        //     }
        //   }
        //   .includecont{
        //     width: 368px;
        //     font-family: PingFangSC-Regular;
        //     font-size: 14px;
        //     font-weight: normal;
        //     font-stretch: normal;
        //     line-height: 24px;
        //     letter-spacing: 0px;
        //     color: #818d99;
        //     margin-bottom:20px;
        //   }
        // }
        // .fprinclude::-webkit-scrollbar{
        // display: none;
        // }
      }
    }
  }
}
  



</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/fwpt.vue